import { render, staticRenderFns } from "./rightMemoView.vue?vue&type=template&id=2435e70e&scoped=true&"
import script from "./rightMemoView.vue?vue&type=script&lang=js&"
export * from "./rightMemoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2435e70e",
  null
  
)

export default component.exports